var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1928 -168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1941 232h38c6.08 0 11-4.925 11-11v-37c0-6.075-4.92-11-11-11h-6v-2c0-1.656-1.34-3-3-3s-3 1.344-3 3v2h-14v-2c0-1.656-1.34-3-3-3s-3 1.344-3 3v2h-6c-6.08 0-11 4.925-11 11v37c0 6.075 4.92 11 11 11zm43-29v-14h-48v32c0 2.761 2.24 5 5 5h20v-12c0-6.075 4.92-11 11-11zm0 8.243v9.757c0 2.761-2.24 5-5 5h-9.76z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.04e9ba76c7cf3e5f7d366ee0a646fc8d.svg";
export { ForwardRef as ReactComponent };